import type { ClientError } from '@tribeplatform/gql-client/lib'
import type {
  MutationUpdateCollectionArgs,
  Collection,
  Action,
} from '@tribeplatform/gql-client/types'

import {
  useMutation,
  type UseMutationOptions,
} from '../../lib/react-query/useMutation.js'
import { useQueryClient } from '../../lib/react-query/useQueryClient.js'
import { useTribeClient } from '../../useTribeClient.js'
import {
  getCollectionKey,
  getCollectionsKey,
} from '../../utils/keys/collection.key.js'

export const useUpdateCollection = (options?: {
  useMutationOptions?: UseMutationOptions<
    Action,
    ClientError,
    MutationUpdateCollectionArgs,
    { snapshot: Collection }
  >
}) => {
  const { useMutationOptions } = options || {}
  const { client } = useTribeClient()
  const queryClient = useQueryClient()

  return useMutation<
    Action,
    ClientError,
    MutationUpdateCollectionArgs,
    { snapshot: Collection }
  >((input: MutationUpdateCollectionArgs) => client.collections.update(input), {
    onSettled: (data, error, variables) => {
      const collectionKey = getCollectionKey({
        variables: { id: variables.id },
      })
      queryClient.invalidateQueries(collectionKey)

      const collectionsKey = getCollectionsKey()
      queryClient.invalidateQueries(collectionsKey)
    },
    ...useMutationOptions,
  })
}
